import { ref, watch } from 'vue'
import type { DonorDonation } from '@/types/donorFinancialYear'
import { useDetailNavigation } from '@/composables/useDetailNavigation'

const isOpen = ref(false)
const selectedDonation = ref<DonorDonation | null>(null)

const { root } = useDetailNavigation()

// The schedules list replaces this detail. Drop the overlay without clearing
// the new stack (that root is no longer a donation).
watch(
  () => root.value?.kind,
  (kind) => {
    if (kind === 'donation' || !isOpen.value) return
    isOpen.value = false
    selectedDonation.value = null
  }
)

/** Shared donation detail, opened from any dashboard donation list row. */
export function useDonationDetailModal() {
  const { root, openRootDonation, closeDetailNavigation, patchDetailDonation } =
    useDetailNavigation()

  const openDonationDetailModal = (donation: DonorDonation) => {
    // A list row starts a fresh modal. It does not sit on top of another detail.
    selectedDonation.value = donation
    isOpen.value = true
    openRootDonation(donation)
  }

  const closeDonationDetailModal = () => {
    isOpen.value = false
    selectedDonation.value = null
    if (root.value?.kind === 'donation') closeDetailNavigation()
  }

  const patchSelectedDonation = (donation: DonorDonation) => {
    selectedDonation.value = donation
    patchDetailDonation(donation)
  }

  return {
    isOpen,
    selectedDonation,
    openDonationDetailModal,
    closeDonationDetailModal,
    patchSelectedDonation,
  }
}
